const NAME = "SYSTEM_AND_USER_TABLES_FIELD_DEFINITION";

export default NAME;
